import {enterGuestMode} from '@sollapay/web-core';
import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

import {config} from '@/app';
import {LoginFormSkeleton} from '@/features/authentication';
import {resolveGuestReturnTo} from '@/features/guest';

import type {FC} from 'react';

export const GuestEntryPage: FC = () => {
  const [searchParams] = useSearchParams();
  const returnTo = resolveGuestReturnTo(searchParams.get('account'));
  const email = searchParams.get('email') ?? undefined;

  useEffect(() => {
    if (config.auth0.guestClientId) enterGuestMode({email, returnTo});
    else window.location.replace('/');
  }, [email, returnTo]);

  return <LoginFormSkeleton />;
};
